"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrl = void 0;
const constants_1 = require("../../constants");
const isUrl = (string) => {
    const regexpValue = new RegExp(constants_1.REG_EXP_LIST.url);
    return regexpValue.test(string);
};
exports.isUrl = isUrl;
//# sourceMappingURL=isUrl.js.map